import React, { FC, ReactElement } from 'react';
import './Footer.scss';

const Footer: FC<any> = (props: any): ReactElement => {
  return (
    <React.Fragment>
      <footer className="footerWrapper">
        <hr></hr>
        <div className="footer-container"></div>
      </footer>
    </React.Fragment>
  );
};

export default React.memo(Footer);
